import Categories from 'ai/constants/availabilityPlacements';

function hasCategoryId(obj, availableCategories) {
    let current = obj;

    while (current) {
        if (availableCategories.some(category => category.id === current.categoryId)) {
            return true;
        }

        current = current.parentCategory;
    }

    return false;
}

function getAllAvailableCategories() {
    const { isGenAIFragranceChatEnabled, isGenAIBathAndBodyChatEnabled, isGenAIToolsAndBrushesChatEnabled } = Sephora.configurationSettings;

    const CATEGORIES_AVAILABLE = [
        ...Categories.GENAI_CATEGORIES_HAIR,
        ...Categories.GENAI_CATEGORIES_SKINCARE,
        ...Categories.GENAI_CATEGORIES_MAKEUP
    ];

    if (isGenAIFragranceChatEnabled) {
        CATEGORIES_AVAILABLE.push(...Categories.GENAI_CATEGORIES_FRAGRANCE);
    }

    if (isGenAIBathAndBodyChatEnabled) {
        CATEGORIES_AVAILABLE.push(...Categories.GENAI_CATEGORIES_BATH_AND_BODY);
    }

    if (isGenAIToolsAndBrushesChatEnabled) {
        CATEGORIES_AVAILABLE.push(...Categories.GENAI_CATEGORIES_TOOLS_AND_BRUSHES);
    }

    return CATEGORIES_AVAILABLE;
}

function isAIBeautyChatEnabledPDP(product) {
    if (!product || !product.parentCategory) {
        return false;
    }

    const { isGenAIChatPDPEnabled } = Sephora.configurationSettings;

    const AVAILABLE_CATEGORIES = getAllAvailableCategories();

    if (hasCategoryId(product.parentCategory, AVAILABLE_CATEGORIES) && isGenAIChatPDPEnabled) {
        return true;
    }

    return false;
}

function isAIBeautyChatEnabledPLP(categoryId) {
    if (!categoryId) {
        return false;
    }

    const { isGenAIChatPLPEnabled } = Sephora.configurationSettings;

    const AVAILABLE_CATEGORIES = getAllAvailableCategories();

    const enablePLP = AVAILABLE_CATEGORIES.some(category => category.id === categoryId);

    if (enablePLP && isGenAIChatPLPEnabled) {
        return true;
    }

    return false;
}

function isAIBeautyChatEnabledSRP(pageType) {
    if (pageType !== 'searchResults') {
        return false;
    }

    const { isGenAIChatSRPEnabled } = Sephora.configurationSettings;

    return isGenAIChatSRPEnabled;
}

export {
    isAIBeautyChatEnabledPDP, isAIBeautyChatEnabledPLP, isAIBeautyChatEnabledSRP
};
